var map = {
	"./Coding Wallpapers 7.jpg": 4312,
	"./accubits.jpg": 4638,
	"./ansys.jpg": 3240,
	"./autodesk.png": 956,
	"./aves_construction.jpeg": 7944,
	"./cubic_spaces.png": 5846,
	"./dassualt_systems.jpg": 4224,
	"./gbri1.png": 3821,
	"./ust_global.jpeg": 7593
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8588;